"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseNotCondition = void 0;
const parseNotCondition = (conditionParser, condition) => {
    const { not: negatedCondition } = condition;
    conditionParser.resetExpression();
    conditionParser.parse(negatedCondition);
    conditionParser.resetExpression(`NOT (${conditionParser.expression})`);
};
exports.parseNotCondition = parseNotCondition;
